var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167,
    y: 0.167,
    width: 21.667,
    height: 21.667,
    rx: 10.833,
    fill: "#0DD1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97 15.965a.89.89 0 01-.583-.233L4.31 11.538a.914.914 0 010-1.281.914.914 0 011.281 0l3.378 3.495 7.106-7.456a.914.914 0 011.282 0c.349.35.349.932 0 1.282l-7.689 8.154c-.233.116-.466.233-.699.233z",
    fill: "#fff"
  })));
}
export default SvgCompleteForm;